/**
 * Language code for Google Maps API
 * Using English to ensure consistent country names across all users regardless of browser language
 */
export const GOOGLE_MAPS_LANGUAGE = "en";
